export const preserveInstitutionParams = (path: string): string => {
  const currentParams = new URLSearchParams(window.location.search);
  const institutionParam = currentParams.get('institution');
  
  if (institutionParam) {
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}institution=${institutionParam}`;
  }
  
  return path;
};

export const createInstitutionAwareUrl = (basePath: string, additionalParams?: Record<string, string>): string => {
  const url = new URL(basePath, window.location.origin);
  
  // Preserve institution parameter from current URL
  const currentParams = new URLSearchParams(window.location.search);
  const institutionParam = currentParams.get('institution');
  
  if (institutionParam) {
    url.searchParams.set('institution', institutionParam);
  }
  
  // Add any additional parameters
  if (additionalParams) {
    Object.entries(additionalParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
  }
  
  return url.pathname + url.search;
}; 